import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "b-search-page" }
const _hoisted_2 = {
  ref: "leftBar",
  class: "b-search-page__left-bar"
}
const _hoisted_3 = { class: "b-search-page__left-bar__inner" }
const _hoisted_4 = { class: "b-search-page__inner" }
const _hoisted_5 = { class: "h-text-center" }
const _hoisted_6 = { class: "b-search-page__inner-activities h-flex h-flex-dir-column h-flex-center" }
const _hoisted_7 = { key: 0 }
const _hoisted_8 = {
  key: 0,
  class: "h-font-18"
}
const _hoisted_9 = { class: "b-profile-worker-page__wrapper" }
const _hoisted_10 = {
  key: 1,
  class: "h-font-18"
}
const _hoisted_11 = { class: "b-profile-worker-page__wrapper" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LeftBarMenu = _resolveComponent("LeftBarMenu")!
  const _component_FinalePopup = _resolveComponent("FinalePopup")!
  const _component_AddOrEditEventPopup = _resolveComponent("AddOrEditEventPopup")!
  const _component_FwInput = _resolveComponent("FwInput")!
  const _component_WorkerCard = _resolveComponent("WorkerCard")!
  const _component_FwPagination = _resolveComponent("FwPagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_LeftBarMenu)
      ])
    ], 512),
    (_ctx.showInfoPopup)
      ? (_openBlock(), _createBlock(_component_FinalePopup, {
          key: 0,
          header: `POPUP.FINALY.EVENT.DELETED`,
          subMessage: `POPUP.FINALY.EVENT.DELETED.TEXT`,
          eventTitle: _ctx.activityTitle,
          showImage: false,
          onClose: _ctx.closePopup
        }, null, 8, ["eventTitle", "onClose"]))
      : _createCommentVNode("", true),
    (_ctx.showPreview)
      ? (_openBlock(), _createBlock(_component_AddOrEditEventPopup, {
          key: 1,
          users: _ctx.users,
          loading: _ctx.loadingEvent,
          event: _ctx.addEventData,
          eventUserId: _ctx.user.id,
          showAvatar: true,
          editDeleteEvent: false,
          originValue: `unavailability`,
          onClose: _ctx.closePopup
        }, null, 8, ["users", "loading", "event", "eventUserId", "onClose"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.$t('SEARCH.PAGE.TITLE')), 1),
      _createElementVNode("div", _hoisted_6, [
        _createVNode(_component_FwInput, {
          class: "h-flex-1 h-ml-15 h-mb-30 h-width-350",
          value: _ctx.searchText,
          placeholder: _ctx.$t(`SEARCH.PAGE.INPUT.PLACEHOLDER`),
          iconRight: "loupe",
          iconSize: "15",
          inputStyle: "search",
          type: "search",
          onInput: _cache[0] || (_cache[0] = value => _ctx.searchText = value)
        }, null, 8, ["value", "placeholder"]),
        (_ctx.workersCardsData.length !== 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_ctx.confirmedUsers.length !== 0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_8, _toDisplayString(_ctx.$t('WORKER.CONFIRMED')) + " (" + _toDisplayString(_ctx.confirmedUsers.length) + ") ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_9, [
                (_ctx.worker.active && _ctx.worker.kind === `technician`)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.preparedWorkersCards, (worker) => {
                      return (_openBlock(), _createBlock(_component_WorkerCard, {
                        key: worker.id,
                        worker: worker,
                        class: "h-mb-20"
                      }, null, 8, ["worker"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.unconfirmedUsers.length !== 0)
                ? (_openBlock(), _createElementBlock("h1", _hoisted_10, _toDisplayString(_ctx.$t('WORKER.UNCONFIRMED')) + " (" + _toDisplayString(_ctx.unconfirmedUsers.length) + ") ", 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_11, [
                (!_ctx.worker.active && _ctx.worker.kind === `technician`)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_ctx.preparedWorkersCards, (worker) => {
                      return (_openBlock(), _createBlock(_component_WorkerCard, {
                        key: worker.id,
                        worker: worker,
                        class: "h-mb-20"
                      }, null, 8, ["worker"]))
                    }), 128))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.totalPage > _ctx.perPage)
                ? (_openBlock(), _createBlock(_component_FwPagination, {
                    key: 2,
                    totalPage: _ctx.totalPage,
                    currentPage: _ctx.currentPage,
                    perPage: _ctx.perPage,
                    value: _ctx.perPage,
                    onGetData: _ctx.getActivities
                  }, null, 8, ["totalPage", "currentPage", "perPage", "value", "onGetData"]))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}